import Card from 'react-bootstrap/Card';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { PageHeader } from 'Components/Public/PageHeader/PageHeader';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { FormInputDisplay } from 'Components/Forms/FormInputDisplay';
import { GetFilterRadioInputData, GetFilterSelectInputData, GetFilterTextInputData } from './FilterFields';
import { Badge, Button, ButtonGroup, Form, Spinner, Toast, ToastContainer, ToggleButton, ToggleButtonGroup } from 'react-bootstrap';
import { DownhillSkiing, TroubleshootRounded, TurnLeftTwoTone } from '@mui/icons-material';
import { ACTIONS as SELECT_ACTIONS}  from 'Components/Forms/FormReducers/SelectInputReducer';
import { IconTextButton } from 'Components/Button';
import { ICONS } from 'Utils/icons';
import FilterDropdown from './FilterDropdown';
import { http } from 'Utils';
import { ACTIONS } from 'Components/Forms/FormReducers/RadioInputReducer';
import { Link } from 'react-router-dom';
import { getDocURL, getResourceDownloadProps } from 'Utils/fileDownloadUtil';
import { ACTIONS as TEXT_ACTIONS}  from 'Components/Forms/FormReducers/TextInputReducer';
import { PageInfo } from 'Components/PageInformation/PageInformation';
import Feedback from 'react-bootstrap/esm/Feedback';
import { displayErrors } from 'Components/Messages/ErrorMessage';
import { setGlobalErrorStatus } from 'Components/StatusHandling';
import { ERROR_MESSAGES } from 'Utils/constants';
import { useDispatch } from 'react-redux';
import { ReCaptchaWrapper } from 'Components/ReCaptcha';
import { PATHS } from 'Utils/PagePaths';

function Articles () {
    const vForm = { is: false, labelCols: { lg: 12, md: 12 }, inputCols: { lg: 12 } };
    const hForm = { is: true, labelCols: { lg: 3, md: 4 }, inputCols: { lg: 5 } };

    const articlePages = [2411];

    var [search, searchInputDispatch] = GetFilterTextInputData('search', "");
    var [topic, topicInputDispatch] = GetFilterSelectInputData('topic', -1);
    var [type, typeInputDispatch] = GetFilterSelectInputData('type', -1);
    var [years, yearsInputDispatch] = GetFilterSelectInputData('years', -1);
    var [sortBy, sortByInputDispatch] = GetFilterRadioInputData('sortBy', 1);
    var [loading, setLoading] = useState(true);
    var [totalResults, setTotalResults] = useState(0);
    
    const dispatch = useDispatch();
    var initialFilters = {
        searchTerm: "",
        sortOption: 1,
        topic: -1,
        type: -1,
        year: -1
    }

    const [filter, setFilter] = useState({
        searchTerm: "",
        sortOption: 1,
        topic: -1,
        type: -1,
        year: -1
    })
    const [articles, setArticles] = useState([]);

    const [filters, setFilters] = useState([
        {
            value: '1991',
            category: 'year'
        }
    ]);

    useEffect(()=>{
        setLoading(true);
        loadInitialDataAPI().then((res)=>{
            console.log(res.data);
            if(res.status!=1){
                setGlobalErrorStatus({
                    dispatch: dispatch,
                    popupData: {
                        visible: true,
                        title: ERROR_MESSAGES.GENERAL_ERROR.title,
                        msg: res.globalErrorMessageList.length>0 ? res.globalErrorMessageList[0] : ERROR_MESSAGES.GENERAL_ERROR.message,
                        showContactHelp: false
                    },
                    redirect: {
                        redirect: false,
                        redirectFirst: false,
                        path: "",
                        data: {}
                    }
                });
            }
            else{ 
                var years = [];
                years.push({
                    index: null,
                    value: -1,
                    title: null,
                    displayValue: "All Years",
                    isSelected: true
                })

                var topics = [];
                topics.push({
                    index: null,
                    value: -1,
                    title: null,
                    displayValue: "All Topics",
                    isSelected: true
                })

                var types = [];
                types.push({
                    index: null,
                    value: -1,
                    title: null,
                    displayValue: "All Types",
                    isSelected: true
                })

                if(res.data!=null){
                    var data = res.data;

                    var yearsData = data.years;
                    var typeData = data.categories;
                    var topicData = data.topics;
                    var sortData = data.sortOption;

                   var sortBy = [];
                    sortBy.push(
                        {
                            id: "new",
                            label: "Newest First",
                            name: "sortBy",
                            value: 1,
                            title: "",
                            isChecked: sortData==1 || sortData=='1'? true : false,
                            variant: 'radioBtnGroup'
                            //onChange: handleRadioChange,
                            //disabled: getDisabledOn({"View":[]},formActionType,orgType)
                        },
                        {
                            id: "old",
                            label: "Oldest First",
                            name: "sortBy",
                            value: 0,
                            title: "",
                            isChecked: sortData==0 || sortData=='0'? true : false,
                            variant: 'radioBtnGroup'
                            //onChange: handleRadioChange,
                            //disabled: getDisabledOn({"View":[]},formActionType,orgType)
                        }
                    );

                    sortByInputDispatch({
                        type: ACTIONS.SET_INITIAL_DATA,
                        radioButtons: sortBy
                    })
                    searchInputDispatch({
                        type: TEXT_ACTIONS.TEXT_CHANGE,
                        value: filter.searchTerm
                    })
                    
                    for(var x = 0 ; x < yearsData.length ; x++){
                        var year = yearsData[x];
                        years.push({
                            index: year,
                            id: year,
                            value: year,
                            title: null,
                            displayValue: year,
                            isSelected: false,
                            name: year,
                            disabled: false
                        })
                    }
                    for(var x = 0 ; x < typeData.length ; x++){
                        var type = typeData[x];
                        console.log(type);
                        types.push({
                            index: type.categoryId,
                            value: type.categoryId,
                            title: null,
                            displayValue: type.categoryName,
                            isSelected: false
                        })
                    }

                    for(var x = 0 ; x < topicData.length ; x++){
                        var topic = topicData[x];
                        console.log(topic);
                        topics.push({
                            index: topic.topicId,
                            value: topic.topicId,
                            title: null,
                            displayValue: topic.topicName,
                            isSelected: false
                        })
                    }
                    
                    yearsInputDispatch({
                        type: SELECT_ACTIONS.SELECT_UPDATE_CHOICES,
                        options: years
                    })
                    typeInputDispatch({
                        type: SELECT_ACTIONS.SELECT_UPDATE_CHOICES,
                        options: types
                    })
                    topicInputDispatch({
                        type: SELECT_ACTIONS.SELECT_UPDATE_CHOICES,
                        options: topics
                    })

                    setTotalResults(res.data.articles.length);
                    setArticles(res.data.articles);
                    
                }
            }
        }).finally(()=>{
            setLoading(false);
        }).catch((err)=>{
            console.log(err);
            setGlobalErrorStatus({
                dispatch: dispatch,
                popupData: {
                    visible: true,
                    title: ERROR_MESSAGES.GENERAL_ERROR.title,
                    msg: ERROR_MESSAGES.GENERAL_ERROR.message,
                    showContactHelp: true
                },
                redirect: {
                    redirect: false,
                    redirectFirst: false,
                    path: "",
                    data: {}
                }
            })
        });
    },[])

    useEffect(()=>{
        console.log(search);
        if(loading==false){
            if(topic.prevValue == filter.topic && type.prevValue == filter.type && years.prevValue == filter.year && sortBy.prevValue == filter.sortOption && sortBy.prevValue==filter.searchTerm){
            }
            else{
                loadFilteredDataAPI(search.value, sortBy.value, topic.value, type.value, years.value).then((res)=>{
                    console.log(res);
                    if(res.data!=null){
                        setArticles(res.data);
                    }
                    if(res.status!=1 && res.globalErrorMessageList.length>0){
                        
                        setGlobalErrorStatus({
                            dispatch: dispatch,
                            popupData: {
                                visible: true,
                                title: ERROR_MESSAGES.GENERAL_ERROR.title,
                                msg: res.globalErrorMessageList.length>0 ? res.globalErrorMessageList[0] : ERROR_MESSAGES.GENERAL_ERROR.message,
                                showContactHelp: false
                            },
                            redirect: {
                                redirect: false,
                                redirectFirst: false,
                                path: "",
                                data: {}
                            }
                        });
                    }
                    else{
                        if(Object.keys(res.fieldErrors).length>0){
                            console.log(res.fieldErrors);
                            var errors = res.fieldErrors;
                            var errData = Object.values(errors);
                            for(var x = 0 ; x<errData.length ; x++){
                                var error = errData[x];
                                switch(error.fieldName){
                                    case 'topics':
                                        topicInputDispatch({
                                            type: SELECT_ACTIONS.SELECT_SET_ERRORS,
                                            errors: errData[x].errorMessages
                                        })
                                        break;
                                    case 'types':
                                        typeInputDispatch({
                                            type: SELECT_ACTIONS.SELECT_SET_ERRORS,
                                            errors: errData[x].errorMessages
                                        })
                                        break;
                                    case 'years':
                                        yearsInputDispatch({
                                            type: SELECT_ACTIONS.SELECT_SET_ERRORS,
                                            errors: errData[x].errorMessages
                                        })
                                        break;
                                    case 'sortOption':
                                        sortByInputDispatch({
                                            type: ACTIONS.RADIO_SET_ERRORS,
                                            errors: errData[x].errorMessages
                                        })
                                        break;
                                    case 'searchTerm':
                                        searchInputDispatch({
                                            type: TEXT_ACTIONS.TEXT_SET_ERRORS,
                                            errors: errData[x].errorMessages
                                        })
                                        break;
                                }
                                
                            }
                        }
                    
                        
                    }
                    
                    
                }).catch((err)=>{
                    console.log(err);
                    setGlobalErrorStatus({
                        dispatch: dispatch,
                        popupData: {
                            visible: true,
                            title: ERROR_MESSAGES.GENERAL_ERROR.title,
                            msg: ERROR_MESSAGES.GENERAL_ERROR.message,
                            showContactHelp: true
                        },
                        redirect: {
                            redirect: false,
                            redirectFirst: false,
                            path: "",
                            data: {}
                        }
                    })
                })
            }
        }
    },[topic.value, type.value, years.value, sortBy.value, search.value])

    
    const loadInitialDataCall = async () => {
        var url = "/api/article/initLoad";
        return http.post(url, null);
    }
    
    const loadInitialDataAPI = async () => {
        const result =  await loadInitialDataCall();
        return result;
    }

    const loadFilteredDataCall = async (searchTerm, sortOption, topic, type, year) => {
        var url = "/api/article/filterArticle";
        var data = {
            searchTerm: searchTerm,
            sortOption: sortOption,
            topic: topic,
            type: type,
            year: year
        }
        return http.post(url, data);
    }
    
    const loadFilteredDataAPI = async (searchTerm, sortOption, topic, type, year) => {
        const result =  await loadFilteredDataCall(searchTerm, sortOption, topic, type, year);
        return result;
    }

    const hasFilters = () =>{
        if(sortBy.value!=1){
            console.log(sortBy.value);
            return true;
        }
        if(topic.value!=-1 || type.value!=-1 || years.value!=-1){
            return true;
        }
        if(search.value!=null && search.value!=""){
            return true;
        }
        
        return false;
        //search.value, sortBy.getValue(sortBy.radioButtons), topic.value, type.value, years.value
    }

    
    const clearFilters = () =>{
        console.log("clearfilters");
        searchInputDispatch({
            type: TEXT_ACTIONS.TEXT_CHANGE,
            value: filter.searchTerm
        })
        yearsInputDispatch({
            type: SELECT_ACTIONS.SELECT_CHANGE,
            value: filter.year
        })
        typeInputDispatch({
            type: SELECT_ACTIONS.SELECT_CHANGE,
            value: filter.type
        })
        topicInputDispatch({
            type: SELECT_ACTIONS.SELECT_CHANGE,
            value: filter.topic
        })
        sortByInputDispatch({
            type: ACTIONS.RADIO_CHANGE,
            value: filter.sortOption
        })
    }

    const getErrorDisplay = (fieldData, classes) =>{
        return (
            <Form.Control.Feedback className={fieldData.validation.isInvalid ? "is-invalid bodyS " + classes : "d-none"} type="invalid">
                {displayErrors(fieldData.name, fieldData.validation.errors) } 
            </Form.Control.Feedback>
        )
    }
    return (
        <>
            <ReCaptchaWrapper
                action="articles_landing"
                title="PSOPPC Articles"
            >
            <Row className="m-0 p-0">
                <PageHeader
                    title="PSOPPC Articles"
                    intro="Explore guidance, best practices, and technical resources to support Patient Safety Organizations (PSOs) in submitting, managing, and analyzing patient safety data through the PSOPPC."
                >
                </PageHeader>
                
                <Row lg={1} className="main-content m-0 mb-5 mt-4 mt-md-5 mt-lg-6 pt-0 pb-4 d-flex justify-content-center g-0 bg-color-base-offwhite">
                    <Col xxl={10} xl={11} lg="11" md={11} xs="11" className="d-flex gap-40px gap-lg-6 flex-column">
                        <div id="filter-bar-container" className="container-style px-3 p-lg-4">
                            <Form className="gx-3 d-flex flex-column">
                                <div className="d-flex flex-wrap flex-row flex-lg-nowrap flex-shrink-1 gap-3">
                                    <Col xs={12} lg={5} className="p-0 flex-shrink-1" >
                                        <Form.Group id="" className="g-0 d-flex flex-row flex-nowrap flex-md-nowrap flex-md-row gap-0">
                                            <Col className="d-flex flex-column  g-0 position-relative">
                                            
                                                <div className="d-flex flex-row align-items-center g-0 lh-1">
                                                    <div className="position-absolute ps-3">
                                                        {ICONS.searchArticles()}
                                                    </div>
                                                    <Form.Control
                                                        type={search.type}
                                                        //key={"searchBar"+itemLocation}
                                                        ref={search.InputRef} 
                                                        value={search.value} 
                                                        onChange={(e)=>{
                                                            var val = e.target.value;
                                                            searchInputDispatch({
                                                                type: TEXT_ACTIONS.TEXT_CHANGE,
                                                                value: val
                                                            })
                                                        }} 
                                                        onKeyDown={(e)=>{
                                                            if(e.code==="Enter"){
                                                                e.preventDefault();
                                                            }
                                                        }}
                                                        
                                                        //autoFocus={hasFocus}
                                                        className={"m-0 body ps-5"}
                                                        id={search.id}
                                                        role="searchbox" 
                                                        aria-label={search.display.placeholder}
                                                        placeholder={search.display.placeholder}
                                                        isInvalid={search.validation.isInvalid}
                                                    >
                                                    </Form.Control>
                                                    
                                                </div>
                                                
                                            </Col>
                                        </Form.Group>
                                        {getErrorDisplay(search,"mt-3 d-flex d-lg-none")}
                                        {/* {search.validation.isInvalid ? <PageInfo classes="mt-3 d-flex d-lg-none" message={search.validation.errors} type={'error'} ></PageInfo> : null} */}
                                    </Col>
                                    {/* Topic and type filters swapped - Prod release update */}
                                    <Col xs={12} lg={2} className="p-0 flex-shrink-1">
                                        <FilterDropdown startVal={filter.type} filteredResults={articles.length} fieldData={type} inputDispatch={typeInputDispatch}></FilterDropdown>
                                        {getErrorDisplay(type,"mt-3 d-flex d-lg-none")}
                                    </Col>
                                    <Col xs={12} lg={5} className="d-flex flex-wrap flex-row flex-lg-nowrap p-0 flex-shrink-1 gap-3 gap-sm-0">
                                        <Col xs={12} sm={7} lg={7} className="pe-0 pe-sm-3">
                                            <FilterDropdown startVal={filter.topic} filteredResults={articles.length} fieldData={topic} inputDispatch={topicInputDispatch}></FilterDropdown>
                                            {getErrorDisplay(topic,"mt-3 d-flex d-sm-none")}
                                        </Col>
                                    {/* <Col xs={12} lg={3} className="p-0 flex-shrink-1">
                                        <FilterDropdown startVal={filter.topic} filteredResults={articles.length} fieldData={topic} inputDispatch={topicInputDispatch}></FilterDropdown>
                                        {getErrorDisplay(topic,"mt-3 d-flex d-lg-none")} */}
                                        {/* {topic.validation.isInvalid ? <PageInfo classes="mt-3 d-flex d-lg-none" message={topic.validation.errors} type={'error'} ></PageInfo> : null} */}
                                    {/* </Col>
                                    <Col xs={12} lg={4} className="d-flex flex-wrap flex-row flex-lg-nowrap p-0 flex-shrink-1 gap-3 gap-sm-0">
                                        <Col xs={12} sm={7} lg={7} className="pe-0 pe-sm-3">
                                            <FilterDropdown startVal={filter.type} filteredResults={articles.length} fieldData={type} inputDispatch={typeInputDispatch}></FilterDropdown>
                                            {getErrorDisplay(type,"mt-3 d-flex d-sm-none")} */}
                                            {/* {type.validation.isInvalid ? <PageInfo classes="mt-3 d-flex d-sm-none" message={type.validation.errors} type={'error'} ></PageInfo> : null}       */}
                                        {/* </Col> */}
                                        <Col xs={12} sm={5} lg={5}>
                                            <FilterDropdown startVal={filter.year} filteredResults={articles.length} fieldData={years} inputDispatch={yearsInputDispatch}></FilterDropdown>
                                            {getErrorDisplay(years,"mt-3 d-flex d-sm-none")}
                                            {/* {years.validation.isInvalid ? <PageInfo classes="mt-3  d-flex d-sm-none" message={years.validation.errors} type={'error'} ></PageInfo> : null} */}
                                        </Col>
                                        <Col >
                                            {getErrorDisplay(type,"mt-3 d-none d-sm-flex d-lg-none")}
                                            {getErrorDisplay(years,"mt-3 d-none d-sm-flex d-lg-none")}
                                            {/* {type.validation.isInvalid ? <PageInfo classes="mt-3 d-none d-sm-flex d-lg-none" message={type.validation.errors} type={'error'} ></PageInfo> : null}       */}
                                            {/* {years.validation.isInvalid ? <PageInfo classes="mt-3 d-none d-sm-flex d-lg-none" message={years.validation.errors} type={'error'} ></PageInfo> : null} */}
                                        </Col>
                                        
                                    </Col>
                                </div>
                                <div className="d-none d-lg-flex flex-column">
                                    {getErrorDisplay(search,"mt-3 d-none d-lg-flex")}
                                    {getErrorDisplay(topic,"mt-3 d-none d-lg-flex")}
                                    {getErrorDisplay(type,"mt-3 d-none d-lg-flex")}
                                    {getErrorDisplay(years,"mt-3 d-none d-lg-flex")}
                                    {getErrorDisplay(sortBy,"mt-3 d-none d-lg-flex")}
                                    {/* {search.validation.isInvalid ? <PageInfo classes="mt-3 d-none d-lg-flex" message={search.validation.errors} type={'error'} ></PageInfo> : null}
                                    {topic.validation.isInvalid ? <PageInfo classes="mt-3 d-none d-lg-flex" message={topic.validation.errors} type={'error'} ></PageInfo> : null}
                                    {type.validation.isInvalid ? <PageInfo classes="mt-3 d-none d-lg-flex" message={type.validation.errors} type={'error'} ></PageInfo> : null}
                                    {years.validation.isInvalid ? <PageInfo classes="mt-3 d-none d-lg-flex" message={years.validation.errors} type={'error'} ></PageInfo> : null}
                                    {sortBy.validation.isInvalid ? <PageInfo classes="mt-3 d-none d-lg-flex" message={sortBy.validation.errors} type={'error'} ></PageInfo> : null} */}
                                </div>
                                <hr className="articles-filter-divider d-none d-lg-block"></hr>
                                <Row xs={1} lg={2} className="d-flex align-items-center flex-column-reverse flex-lg-row justify-content-lg-start mt-3 mt-lg-0 g-0">
                                    <Col  className="w-lg-fit-content showing-items-num me-lg-3">
                                        <p className="text-center text-lg-start mb-0 bodyS color-base-darkgray regular">Showing {articles.length} of {totalResults} articles.</p>
                                    </Col>
                                    <Col lg={'auto'} className="flex-grow-1">
                                        <div className="d-flex flex-column-reverse flex-lg-row justify-content-between flex-grow-1 align-items-center gap-lg-3">
                                            {
                                                filters.map((filter)=>{
                                                    return (
                                                        <IconTextButton
                                                            content={"Clear Filters"}//filter.value}
                                                            icon={ICONS.cancel}
                                                            variant="comp-plain-filter"
                                                            className="reverse clear-filters mt-lg-0 mb-lg-0 align-items-center "
                                                            disabled = {hasFilters()==false}
                                                            onClick={()=>{
                                                                clearFilters();
                                                            }}
                                                        >
                                                        </IconTextButton>
                                                    )
                                                })
                                            }
                                            {/* {
                                                filters.map((filter)=>{
                                                    return (
                                                        <IconTextButton
                                                            content={filter.value}
                                                            icon={ICONS.cancel}
                                                            variant="comp-plain-filter"
                                                            className="reverse clear-filters mt-lg-0 mb-lg-0 align-items-center "
                                                            
                                                            onClick={()=>{
                                                                clearFilters();
                                                            }}
                                                        >
                                                        </IconTextButton>
                                                    )
                                                })
                                            } */}
                                            <div className="d-flex flex-column flex-lg-row gap-3 align-self-stretch align-items-center">
                                                <p className="text-start mb-0 bodyS color-base-darkgray regular sort-by-text">Sort by:</p>
                                                {/* <Form.Group>
                                                    <Form.Check
                                                        key={1}
                                                        type="radio"
                                                        id={1}
                                                        //inline={fieldData.display.inline!=null ? fieldData.display.inline : true}
                                                        //title={v.title}
                                                        label={"Newest First"}
                                                        name={"sortBy"}
                                                        value={1}
                                                        onChange={(e) => {
                                                            console.log(e);
                                                        }}
                                                        checked={sortBy.isChecked}
                                                        //isInvalid={fieldData.validation.isInvalid ? "invalid" : ""}
                                                        //isValid={fieldData.validation.isValid ? "valid" : ""}
                                                        //readOnly={getVarValue(v.readOnly) ? 'readOnly' : ''}
                                                        
                                                        //aria-label="test"

                                                        
                                                    />
                                                </Form.Group> */}
                                                <FormInputDisplay classes="toggle-radio-input" rowClasses={"form-element-container w-100"} fieldData={sortBy} inputDispatch={sortByInputDispatch} isHorizontal={false} hideLabel={true} horizontalForm={vForm}></FormInputDisplay>   
                                                {getErrorDisplay(sortBy,"mt-0 d-flex d-lg-none")}
                                                {/* {sortBy.validation.isInvalid ? <PageInfo classes="mt-3" message={sortBy.validation.errors} type={'error'} ></PageInfo> : null} */}
                                            
                                            </div>
                                        </div>
                                    </Col>
                                </Row>                         
                            </Form>
                        </div>

                        <div id="article-list-container" className="">
                            {
                                loading==true
                                ?
                                    <Spinner variant="table-load-spinner" size="lg" animation="border" className="justify-self-center align-self-center m-4" />
                                :
                                    <Row xs={1} md={2} lg={3} className="gx-4 gy-4 ">
                                        {
                                            articles.map((art, index) => {
                                                return (
                                                    <Col>
                                                        <Card 
                                                            className="p-4 d-flex flex-column gap-3 align-items-start text-start h-100 article-card" 
                                                            {...getResourceDownloadProps(art.groupId)}

                                                            // Uncomment for indiv article pages
                                                            // as={Link}
                                                            // to={articlePages.includes(art.groupId) ? (PATHS.public.Article).replace(":id",art.groupId) : getDocURL(art.groupId)}
                                                            // target={articlePages.includes(art.groupId) ? "" : "_blank"}
                                                            // download={articlePages.includes(art.groupId) ? false : true}
                                                        >
                                                         
                                                            <div className="d-flex flex-row justify-content-between align-items-center w-100">
                                                                <div className="bodyS semibold color-base-darkgray">{art.categoryShortName}</div>
                                                                <div className="p-0">
                                                                    <div className="article-download-icon">{ICONS.downloadoutline()}</div> 
                                                                    {/* Uncomment for indiv article pages */}
                                                                    {/* 
                                                                        {
                                                                            articlePages.includes(art.groupId) 
                                                                            ?   null
                                                                            :   <div className="article-download-icon">{ICONS.downloadoutline()}</div> 
                                                                        } 
                                                                    */}
                                                                </div> 
                                                            </div>
                                                            <div className="header4 semibold color-primary-oxfordblue">{art.title}</div>
                                                            <div className="d-flex flex-column gap-2">
                                                                <div className="d-flex flex-row gap-2">
                                                                    <span className="bodyXS bold color-base-darkergray">{art.issueNumber}</span><span className="color-base-darkgray">•</span><span className="bodyXS regular color-base-darkgray">{art.publishMonthYear}</span>
                                                                </div>
                                                                {
                                                                    art.topic!=null 
                                                                    ?
                                                                        <div className="d-flex flex-row flex-wrap gap-2">
                                                                            {
                                                                                Array.isArray(art.topic)
                                                                                ?
                                                                                    (art.topic).map((t)=>{
                                                                                        return (<Badge bg="category" className="bodyXS color-confirmation-jeanblue bg-color-confirmation-lightblue semibold">{t}</Badge>);
                                                                                    })
                                                                                :   <Badge bg="category" className="bodyXS color-confirmation-jeanblue bg-color-confirmation-lightblue semibold">{art.topic}</Badge>
                                                                            }
                                                                        </div>
                                                                    :   null
                                                                }
                                                                
                                                            </div>
                                                            <p className="body regular mb-0 color-base-darkergray">{art.summary}</p>
                                                        </Card>
                                                    </Col>
                                                )
                                            })
                                        }
                                    </Row>
                            }
                        </div>
                    </Col>
                </Row>
            </Row>
            </ReCaptchaWrapper>
        </>
    );
}

export default Articles;
